import { UserCreateComponent } from './user-create.component';

export default UserCreateComponent;
